<div *ngIf="trafficRule" [froalaView]="trafficRule.description"></div>

